(() => {
  const initCarousel = (carousel) => {
    if (!carousel || carousel.dataset.carouselReady === 'true') return;
    const track = carousel.querySelector('[data-product-carousel-track]');
    const prev = carousel.querySelector('[data-product-carousel-prev]');
    const next = carousel.querySelector('[data-product-carousel-next]');
    if (!track || !prev || !next) return;

    carousel.dataset.carouselReady = 'true';
    let raf = null;

    const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
    const update = () => {
      const max = maxScroll();
      carousel.classList.toggle('is-static', max <= 4);
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= max - 4;
      prev.setAttribute('aria-disabled', String(prev.disabled));
      next.setAttribute('aria-disabled', String(next.disabled));
    };

    const scrollStep = () => {
      const card = track.querySelector('.dlf-product-card');
      if (!card) return Math.max(260, track.clientWidth * .72);
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      const cardStep = card.getBoundingClientRect().width + gap;
      const visibleCards = Math.max(1, Math.floor(track.clientWidth / cardStep));
      return cardStep * Math.max(1, visibleCards - 1);
    };

    const move = (direction) => {
      track.scrollBy({ left: direction * scrollStep(), behavior: 'smooth' });
    };

    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  };

  const initAll = (root = document) => root.querySelectorAll('[data-product-carousel]').forEach(initCarousel);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
